export default __webpack_public_path__ + "static/media/replay_passive.755587c9.svg";